module.exports = __webpack_public_path__ + "339433d541ba14c672f97fa5af7876a3.jpg";